import { render, staticRenderFns } from "./disabled-button.vue?vue&type=template&id=a395884c&"
import script from "./disabled-button.vue?vue&type=script&lang=js&"
export * from "./disabled-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports